import { HeaderButton } from '@altify/components';
import { useContent } from '@altify/utils';
import { createFileRoute, Outlet, useMatchRoute } from '@tanstack/react-router';
import BackButton from 'components/BackButton/BackButton';
import { useState } from 'react';
import { holdingsApi } from 'store/slices/holdings-api';
import { productsApi } from 'store/slices/products-api';
import { preloadQueries } from 'utils/preloading';
import { OrderTypeModal } from './components/OrderTypeModal/OrderTypeModal';
import { tradeSharedContent } from './tradeShared.content';

export const Route = createFileRoute('/_authenticated/trade')({
  component: TradeLayout,
  loader: async () => {
    await preloadQueries(
      productsApi.endpoints.getAvailableProducts.initiate(),
      holdingsApi.endpoints.getHoldings.initiate(),
    );
  },
});

function TradeLayout() {
  const [orderTypeModalIsOpen, setOrderTypeModalIsOpen] = useState(false);
  const localizedContent = useContent(tradeSharedContent);
  const matchRoute = useMatchRoute();

  const orderTypes = [
    {
      route: '/trade/buy-now',
      title: localizedContent.buyNow,
    },
    {
      route: '/trade/sell-now',
      title: localizedContent.sellNow,
    },
    {
      route: '/trade/recurring-buy',
      title: localizedContent.recurringBuy,
    },
  ];

  const currentOrderType = orderTypes.find(orderType =>
    matchRoute({ to: orderType.route }),
  )!;

  return (
    <div className="h-full px-8">
      <BackButton
        className={
          'w-full text-left mt-1 ml-0 pl-6 lg:mt-2 pt-2 lg:ml-0 lg:pl-0 lg:pt-0'
        }
      />
      <div className="w-full items-center flex flex-col">
        <div className="flex flex-col items-center mt-14 max-w-[500px] w-full">
          <HeaderButton
            title={currentOrderType.title}
            onPress={() => {
              setOrderTypeModalIsOpen(true);
            }}
          />
          <Outlet />
        </div>
      </div>
      {orderTypeModalIsOpen && (
        <OrderTypeModal
          isOpen={orderTypeModalIsOpen}
          onClose={() => setOrderTypeModalIsOpen(false)}
        />
      )}
    </div>
  );
}

export default TradeLayout;
